import { Flex, Text } from '@vtex/shoreline'
import styled from 'styled-components'

export const DataContainer = styled(Flex)`
  padding: var(--sl-space-4) 0;
  border-bottom: var(--sl-border-base);
`

export const LabelText = styled(Text)`
  flex: 1;
`

export const CheckboxContainer = styled.div`
  padding: var(--sl-space-5) 0;
  margin-bottom: var(--sl-space-20);
`
